(function () {
  'use strict';

  var completed = false;
  var attempts = 0;
  var maxAttempts = 20;
  var observer;

  function addPaymentIconAltText() {
    var icon = document.querySelector(
      'img.qsc2-drawer-footer__trust-badge-icon[src*="bfaa13c64b6ea06f289f.svg"]'
    );
    if (!icon || icon.getAttribute('alt')) return false;

    icon.setAttribute('alt', 'American Express');
    return true;
  }

  function watchPaymentIconAltText() {
    if (addPaymentIconAltText()) return;

    var paymentIconObserver = new MutationObserver(function () {
      if (addPaymentIconAltText()) paymentIconObserver.disconnect();
    });

    paymentIconObserver.observe(document.documentElement, {
      childList: true,
      subtree: true
    });

    window.setTimeout(function () {
      paymentIconObserver.disconnect();
    }, 15000);
  }

  function revealAllOptions(box) {
    box.querySelectorAll('[hidden]').forEach(function (element) {
      if (element.getAttribute('data-esr-out-of-stock') === 'true') return;
      element.removeAttribute('hidden');
    });

    box.querySelectorAll('.cbb-hidden, .hidden').forEach(function (element) {
      element.classList.remove('cbb-hidden', 'hidden');
    });

    box.querySelectorAll('[style*="display: none"], [style*="display:none"]').forEach(function (element) {
      if (/product|recommend|item|bundle/i.test(element.className || '')) {
        element.style.removeProperty('display');
      }
    });
  }

  function optionIsAvailable(option) {
    if (!option || option.disabled) return false;

    var text = (option.textContent || '').replace(/\s+/g, ' ').trim();
    return !/(sold\s*out|out\s*of\s*stock|currently\s*unavailable|unavailable)/i.test(text);
  }

  function productIsUnavailable(card, index) {
    if (!card || index === 0) return false;

    if (card.matches(
      '.sold-out,.soldout,.out-of-stock,.unavailable,' +
      '[data-available="false"],[data-in-stock="false"],[data-stock-status="out-of-stock"]'
    )) return true;

    var checkbox = card.querySelector('.cbb-frequently-bought-selector-input');
    if (checkbox && checkbox.disabled) return true;

    var select = card.querySelector('select');
    if (select && select.options.length) {
      return !Array.prototype.some.call(select.options, optionIsAvailable);
    }

    var status = card.querySelector(
      '[class*="stock"],[class*="availability"],[class*="sold-out"],' +
      '[class*="soldout"],[class*="out-of-stock"],[data-stock-status]'
    );
    var statusText = status ? status.textContent : card.textContent;
    return /(sold\s*out|out\s*of\s*stock|currently\s*unavailable)/i.test(statusText || '');
  }

  function hideUnavailableRecommendations(scope) {
    if (!scope) return;

    var cards = Array.prototype.slice.call(
      scope.querySelectorAll('.cbb-frequently-bought-products > .cbb-frequently-bought-product')
    );

    cards.forEach(function (card, index) {
      if (!productIsUnavailable(card, index)) return;

      var checkbox = card.querySelector('.cbb-frequently-bought-selector-input');
      if (checkbox && checkbox.checked && !checkbox.disabled) checkbox.click();
      if (checkbox) checkbox.disabled = true;

      card.setAttribute('data-esr-out-of-stock', 'true');
      card.setAttribute('aria-hidden', 'true');
      card.setAttribute('hidden', '');
    });
  }

  function addOptionalMessage(box) {
    var message = document.querySelector('.esr-fbt-optional-message');
    if (!message) {
      message = document.createElement('p');
      message.className = 'esr-fbt-optional-message';
      message.textContent = 'Optional accessories — select only what you want to add.';
    }

    var recommendations = box.querySelector('.cbb-frequently-bought-recommendations-container');
    if (recommendations && recommendations.previousElementSibling !== message) {
      recommendations.insertAdjacentElement('beforebegin', message);
    }
  }

  function positionFbtBelowProduct(container) {
    var product = document.querySelector('[id^="ProductSection-"] .product-single');
    if (!product || !container) return;

    if (product.nextElementSibling !== container) {
      product.insertAdjacentElement('afterend', container);
    }

    container.classList.add('esr-fbt-full-width');
  }

  function initializeFbtCarousel(container) {
    if (!container) return false;

    var products = container.querySelector('.cbb-frequently-bought-products');
    var recommendations = container.querySelector('.cbb-frequently-bought-recommendations-container');
    if (!products || !recommendations) return false;

    var formTile = products.querySelector('.cbb-frequently-bought-product-form-tile');
    var summary = recommendations.querySelector('.esr-fbt-summary-list');

    if (!summary) {
      summary = document.createElement('ul');
      summary.className = 'esr-fbt-summary-list';
      products.insertAdjacentElement('afterend', summary);
    }

    if (formTile && formTile.parentElement !== summary) summary.appendChild(formTile);

    recommendations.classList.add('esr-fbt-carousel-shell');

    var previous = recommendations.querySelector('.esr-fbt-scroll-button--previous');
    var next = recommendations.querySelector('.esr-fbt-scroll-button--next');

    function replaceNativeButton(control) {
      if (!control || control.tagName !== 'BUTTON') return control;
      var replacement = document.createElement('span');
      replacement.className = control.className;
      replacement.setAttribute('aria-label', control.getAttribute('aria-label'));
      replacement.innerHTML = control.innerHTML;
      control.replaceWith(replacement);
      return replacement;
    }

    previous = replaceNativeButton(previous);
    next = replaceNativeButton(next);

    if (!previous) {
      previous = document.createElement('span');
      previous.className = 'esr-fbt-scroll-button esr-fbt-scroll-button--previous';
      previous.setAttribute('aria-label', 'Previous recommended products');
      previous.innerHTML = '&#8249;';
      recommendations.appendChild(previous);
    }

    if (!next) {
      next = document.createElement('span');
      next.className = 'esr-fbt-scroll-button esr-fbt-scroll-button--next';
      next.setAttribute('aria-label', 'Next recommended products');
      next.innerHTML = '&#8250;';
      recommendations.appendChild(next);
    }

    [previous, next].forEach(function (control) {
      control.setAttribute('role', 'button');
      control.setAttribute('tabindex', '0');
    });

    function updateButtons() {
      var maximum = products.scrollWidth - products.clientWidth;
      var previousDisabled = products.scrollLeft <= 2;
      var nextDisabled = products.scrollLeft >= maximum - 2 || maximum <= 2;
      previous.classList.toggle('is-disabled', previousDisabled);
      next.classList.toggle('is-disabled', nextDisabled);
      previous.setAttribute('aria-disabled', String(previousDisabled));
      next.setAttribute('aria-disabled', String(nextDisabled));
    }

    previous.onclick = function (event) {
      event.preventDefault();
      event.stopPropagation();
      products.scrollBy({ left: products.clientWidth * -0.85, behavior: 'smooth' });
      return false;
    };
    next.onclick = function (event) {
      event.preventDefault();
      event.stopPropagation();
      products.scrollBy({ left: products.clientWidth * 0.85, behavior: 'smooth' });
      return false;
    };

    [previous, next].forEach(function (control) {
      control.onkeydown = function (event) {
        if (event.key === 'Enter' || event.key === ' ') control.click();
      };
    });

    if (products.getAttribute('data-esr-carousel-ready') !== 'true') {
      products.addEventListener('scroll', updateButtons, { passive: true });
      window.addEventListener('resize', updateButtons);
      products.setAttribute('data-esr-carousel-ready', 'true');
    }

    window.setTimeout(updateButtons, 100);
    return true;
  }

  function enableHighResolutionGallery() {
    document.addEventListener('click', function (event) {
      var thumbnail = event.target.closest('.product-single__thumbnail');
      if (!thumbnail) return;

      var highResolutionUrl = thumbnail.getAttribute('data-zoom') || thumbnail.href;
      if (!highResolutionUrl) return;

      window.setTimeout(function () {
        var mainImage = document.querySelector('.product-single__photo a img');
        var mainImageLink = document.querySelector('.product-single__photo a');

        if (mainImage) {
          mainImage.removeAttribute('srcset');
          mainImage.src = highResolutionUrl;
        }

        if (mainImageLink) mainImageLink.href = highResolutionUrl;
      }, 80);
    });
  }

  function enableFbtNavigation() {
    document.addEventListener('click', function (event) {
      var control = event.target.closest('.esr-fbt-scroll-button');
      if (!control) return;

      event.preventDefault();
      event.stopPropagation();

      var shell = control.closest('.esr-fbt-carousel-shell');
      var products = shell && shell.querySelector('.cbb-frequently-bought-products');
      if (!products) return;

      var direction = control.classList.contains('esr-fbt-scroll-button--next') ? 1 : -1;
      products.scrollBy({ left: products.clientWidth * 0.85 * direction, behavior: 'smooth' });
    }, true);
  }

  function initializePremiumThumbnails() {
    if (!window.jQuery || !window.jQuery.fn || !window.jQuery.fn.slick) return false;

    var $slider = window.jQuery('.product-single__thumbnails');
    if (!$slider.length || $slider.attr('data-esr-premium-ready') === 'true') return false;

    if ($slider.hasClass('slick-initialized')) $slider.slick('unslick');

    $slider.slick({
      accessibility: true,
      arrows: true,
      autoplay: false,
      dots: false,
      draggable: true,
      infinite: false,
      nextArrow: '<button type="button" class="esr-thumb-arrow esr-thumb-arrow--next" aria-label="Next product images">&#8250;</button>',
      prevArrow: '<button type="button" class="esr-thumb-arrow esr-thumb-arrow--previous" aria-label="Previous product images">&#8249;</button>',
      slidesToScroll: 1,
      slidesToShow: 5,
      swipe: true,
      vertical: false,
      verticalSwiping: false,
      responsive: [
        {
          breakpoint: 1100,
          settings: { slidesToShow: 4 }
        },
        {
          breakpoint: 560,
          settings: { slidesToShow: 3 }
        }
      ]
    });

    $slider.attr('data-esr-premium-ready', 'true');
    return true;
  }

  function initializeMainGalleryNavigation() {
    var main = document.querySelector('[id^="ProductSection-"] .photos__item--main');
    if (!main || main.getAttribute('data-esr-main-navigation') === 'true') return false;

    var previous = document.createElement('span');
    previous.className = 'esr-main-gallery-arrow esr-main-gallery-arrow--previous';
    previous.setAttribute('aria-label', 'Previous product image');
    previous.setAttribute('role', 'button');
    previous.setAttribute('tabindex', '0');
    previous.innerHTML = '&#8249;';

    var next = document.createElement('span');
    next.className = 'esr-main-gallery-arrow esr-main-gallery-arrow--next';
    next.setAttribute('aria-label', 'Next product image');
    next.setAttribute('role', 'button');
    next.setAttribute('tabindex', '0');
    next.innerHTML = '&#8250;';

    main.appendChild(previous);
    main.appendChild(next);
    main.setAttribute('data-esr-main-navigation', 'true');
    return true;
  }

  function enableMainGalleryNavigation() {
    function changeImage(control) {
      var thumbnails = Array.prototype.slice.call(
        document.querySelectorAll('.product-single__thumbnails .product-single__thumbnail-item:not(.slick-cloned) .product-single__thumbnail')
      );
      if (!thumbnails.length) return;

      var activeIndex = thumbnails.findIndex(function (thumbnail) {
        return thumbnail.closest('.product-single__thumbnail-item').classList.contains('is-active');
      });
      if (activeIndex < 0) activeIndex = 0;

      var direction = control.classList.contains('esr-main-gallery-arrow--next') ? 1 : -1;
      var targetIndex = (activeIndex + direction + thumbnails.length) % thumbnails.length;
      thumbnails[targetIndex].click();

      if (window.jQuery && window.jQuery.fn && window.jQuery.fn.slick) {
        window.jQuery('.product-single__thumbnails').slick('slickGoTo', targetIndex);
      }
    }

    document.addEventListener('click', function (event) {
      var control = event.target.closest('.esr-main-gallery-arrow');
      if (!control) return;
      event.preventDefault();
      event.stopPropagation();
      changeImage(control);
    }, true);

    document.addEventListener('keydown', function (event) {
      var control = event.target.closest('.esr-main-gallery-arrow');
      if (!control || (event.key !== 'Enter' && event.key !== ' ')) return;
      event.preventDefault();
      changeImage(control);
    });
  }

  function schedulePremiumThumbnails() {
    var attempts = 0;
    var thumbnailInterval = window.setInterval(function () {
      attempts += 1;
      var thumbnailsReady = initializePremiumThumbnails();
      var mainNavigationReady = initializeMainGalleryNavigation();
      if ((thumbnailsReady && mainNavigationReady) || attempts >= 20) {
        window.clearInterval(thumbnailInterval);
      }
    }, 150);
  }

  function configureFbt() {
    var box = document.getElementById('cbb-frequently-bought-box');
    var container = document.querySelector('.cbb-frequently-bought-container');
    if (!box && !container) return;

    if (box) revealAllOptions(box);
    if (container) {
      revealAllOptions(container);
      positionFbtBelowProduct(container);
      hideUnavailableRecommendations(container);
      initializeFbtCarousel(container);
    }

    if (box && !container) hideUnavailableRecommendations(box);
    if (completed) return;

    var selectors = Array.prototype.slice.call(
      document.querySelectorAll('.cbb-frequently-bought-selector-input')
    ).filter(function (checkbox) {
      return !checkbox.closest('[data-esr-out-of-stock="true"]');
    });

    if (selectors.length < 2) return;

    addOptionalMessage(container || box);

    if (!selectors[0].checked && !selectors[0].disabled) selectors[0].click();

    var optionalSelectors = selectors.slice(1);
    var selectedOptionals = optionalSelectors.filter(function (checkbox) {
      return checkbox.checked;
    });

    selectedOptionals.reverse().forEach(function (checkbox) {
      checkbox.click();
    });

    window.setTimeout(function () {
      attempts += 1;
      if (box) revealAllOptions(box);
      if (container) {
        revealAllOptions(container);
        hideUnavailableRecommendations(container);
      } else if (box) {
        hideUnavailableRecommendations(box);
      }

      var current = Array.prototype.slice.call(
        document.querySelectorAll('.cbb-frequently-bought-selector-input')
      ).filter(function (checkbox) {
        return !checkbox.closest('[data-esr-out-of-stock="true"]');
      });
      var mainSelected = current.length > 0 && current[0].checked;
      var stillSelected = current.slice(1).some(function (checkbox) {
        return checkbox.checked;
      });

      if ((mainSelected && !stillSelected) || attempts >= maxAttempts) {
        completed = true;
        (container || box).setAttribute('data-esr-optionals-ready', 'true');
      }
    }, 250);
  }

  function initialize() {
    var style = document.createElement('style');
    style.textContent =
      '.esr-fbt-optional-message{margin:18px 0 8px;color:#3A4949;font-size:14px;font-weight:700;line-height:1.45}' +
      '#cbb-frequently-bought-box [class*="recommendation"],' +
      '#cbb-frequently-bought-box [class*="product-item"]{' +
      'visibility:visible!important;opacity:1!important;}' +
      '#cbb-frequently-bought-box [data-esr-out-of-stock="true"]{display:none!important;}' +
      '.main-content{padding-bottom:0!important;}' +
      '.template-product .main-content{margin-top:18px!important;}' +
      '#shopify-section-esr-judgeme-product-reviews{margin-bottom:0!important;padding-bottom:0!important;}' +
      '.esr-reviews{margin-bottom:0!important;}' +
      '#shopify-section-footer,.site-footer{margin-top:0!important;}' +
      '[id^="ProductSection-"] .photos{display:flex!important;flex-direction:column!important;width:100%!important;}' +
      '[id^="ProductSection-"]{padding-top:14px!important;}' +
      '[id^="ProductSection-"] .photos__item--main{float:none!important;order:1;position:relative;width:100%!important;}' +
      '[id^="ProductSection-"] .product-single__photo{align-items:center;display:flex!important;justify-content:center;max-height:510px!important;overflow:hidden;}' +
      '[id^="ProductSection-"] .product-single__photo>a{align-items:center;display:flex!important;height:510px;justify-content:center;width:100%;}' +
      '[id^="ProductSection-"] .product-single__photo img{height:100%!important;max-height:510px!important;object-fit:contain!important;width:100%!important;}' +
      '[id^="ProductSection-"] .photos__item--thumbs{float:none!important;margin-top:12px!important;order:2;padding:0 50px!important;position:relative;width:100%!important;}' +
      '[id^="ProductSection-"] .product-single__thumbnails{margin:0!important;width:100%!important;}' +
      '[id^="ProductSection-"] .product-single__thumbnail-item{box-sizing:border-box!important;padding:5px!important;}' +
      '[id^="ProductSection-"] .product-single__thumbnail{background:#fff;border:1px solid #d9d9d9;border-radius:8px;box-shadow:0 4px 14px rgba(0,0,0,.06);display:block;overflow:hidden;padding:5px;transition:border-color .2s ease,box-shadow .2s ease,transform .2s ease;}' +
      '[id^="ProductSection-"] .product-single__thumbnail:hover{border-color:#3a4949;box-shadow:0 7px 18px rgba(0,0,0,.12);transform:translateY(-2px);}' +
      '[id^="ProductSection-"] .product-single__thumbnail-item.is-active .product-single__thumbnail{border:2px solid #d71d24;box-shadow:0 0 0 3px rgba(215,29,36,.12),0 8px 20px rgba(0,0,0,.14);padding:4px;}' +
      '[id^="ProductSection-"] .product-single__thumbnail img{aspect-ratio:1/1;display:block;height:82px!important;object-fit:contain;width:100%;}' +
      '[id^="ProductSection-"] .esr-main-gallery-arrow{align-items:center;background:rgba(25,24,25,.94);border:1px solid rgba(255,255,255,.9);border-radius:4px;box-shadow:0 2px 0 #d71d24,0 6px 14px rgba(0,0,0,.2);color:transparent;cursor:pointer;display:flex;font-size:0;height:29px;justify-content:center;line-height:0;position:absolute;top:50%;transform:translateY(-50%);transition:background .18s ease,border-color .18s ease,box-shadow .18s ease,transform .18s ease;width:29px;z-index:6;}' +
      '[id^="ProductSection-"] .esr-main-gallery-arrow:before{border-right:2px solid #fff;border-top:2px solid #fff;content:"";height:6px;left:50%;position:absolute;top:50%;width:6px;}' +
      '[id^="ProductSection-"] .esr-main-gallery-arrow:after{content:"";inset:-10px;position:absolute;}' +
      '[id^="ProductSection-"] .esr-main-gallery-arrow--previous:before{transform:translate(-38%,-50%) rotate(-135deg);}' +
      '[id^="ProductSection-"] .esr-main-gallery-arrow--next:before{transform:translate(-62%,-50%) rotate(45deg);}' +
      '[id^="ProductSection-"] .esr-main-gallery-arrow:hover{background:#d71d24;border-color:#d71d24;box-shadow:0 3px 0 #191819,0 11px 22px rgba(0,0,0,.24);transform:translateY(calc(-50% - 2px));}' +
      '[id^="ProductSection-"] .esr-main-gallery-arrow:focus-visible{outline:2px solid #fff;outline-offset:-5px;box-shadow:0 0 0 2px #d71d24,0 9px 20px rgba(0,0,0,.22);}' +
      '[id^="ProductSection-"] .esr-main-gallery-arrow--previous{left:18px;}' +
      '[id^="ProductSection-"] .esr-main-gallery-arrow--next{right:18px;}' +
      '[id^="ProductSection-"] .esr-thumb-arrow{align-items:center;background:#191819!important;border:1px solid #3a4949!important;border-radius:50%;color:#fff!important;cursor:pointer;display:flex!important;font-size:30px;height:38px;justify-content:center;line-height:1;padding:0;position:absolute;top:50%;transform:translateY(-50%);transition:background .2s ease,border-color .2s ease;width:38px;z-index:4;}' +
      '[id^="ProductSection-"] .esr-thumb-arrow:hover,[id^="ProductSection-"] .esr-thumb-arrow:focus-visible{background:#d71d24!important;border-color:#d71d24!important;outline:2px solid #fff;outline-offset:2px;}' +
      '[id^="ProductSection-"] .esr-thumb-arrow--previous{left:-45px;}' +
      '[id^="ProductSection-"] .esr-thumb-arrow--next{right:-45px;}' +
      '[id^="ProductSection-"] .esr-thumb-arrow.slick-disabled{cursor:default;opacity:.25;}' +
      '[id^="ProductSection-"] .esr-fbt-full-width{background:linear-gradient(180deg,#f7f8f8 0%,#eef0f0 100%);border:1px solid #dfe3e3;border-top:4px solid #d71d24;border-radius:0 0 12px 12px;box-shadow:0 18px 45px rgba(25,24,25,.08);box-sizing:border-box;margin:34px auto 0!important;max-width:1450px;overflow:hidden;padding:26px 24px 24px!important;width:100%!important;}' +
      '[id^="ProductSection-"] .esr-fbt-full-width>.cbb-frequently-bought-title{color:#191819!important;font-size:28px!important;letter-spacing:-.02em;line-height:1.1;margin:0 0 8px!important;}' +
      '[id^="ProductSection-"] .esr-fbt-full-width>.cbb-frequently-bought-discount-message-container{display:none!important;}' +
      '[id^="ProductSection-"] .esr-fbt-full-width .esr-fbt-carousel-shell{box-sizing:border-box;padding:0 30px;position:relative;}' +
      '[id^="ProductSection-"] .esr-fbt-full-width .cbb-frequently-bought-products{align-items:start!important;display:grid!important;gap:14px!important;grid-auto-columns:calc((100% - 70px)/6)!important;grid-auto-flow:column!important;grid-template-columns:none!important;height:auto!important;margin:0!important;overflow-x:auto!important;overscroll-behavior-inline:contain;padding:4px 0 8px!important;scroll-behavior:smooth;scroll-snap-type:x mandatory;scrollbar-width:none;width:100%!important;}' +
      '[id^="ProductSection-"] .esr-fbt-full-width .cbb-frequently-bought-products::-webkit-scrollbar{display:none;}' +
      '[id^="ProductSection-"] .esr-fbt-full-width .cbb-frequently-bought-products>.cbb-frequently-bought-product{background:#fff;border:1px solid #e0e4e4;border-radius:9px;box-shadow:0 5px 16px rgba(25,24,25,.055);box-sizing:border-box!important;height:auto!important;margin:0!important;max-width:none!important;min-width:0!important;overflow:hidden;padding:12px!important;transition:border-color .2s ease,box-shadow .2s ease,transform .2s ease;width:100%!important;}' +
      '[id^="ProductSection-"] .esr-fbt-full-width .cbb-frequently-bought-products>.cbb-frequently-bought-product:hover{border-color:#bdc4c4;box-shadow:0 10px 24px rgba(25,24,25,.1);transform:translateY(-2px);}' +
      '[id^="ProductSection-"] .esr-fbt-full-width .cbb-frequently-bought-products>.cbb-frequently-bought-product{scroll-snap-align:start;}' +
      '[id^="ProductSection-"] .esr-fbt-full-width .cbb-frequently-bought-product-compact-wrapper{box-sizing:border-box!important;height:auto!important;max-width:none!important;width:100%!important;}' +
      '[id^="ProductSection-"] .esr-fbt-full-width .cbb-frequently-bought-plus-icon{display:none!important;}' +
      '[id^="ProductSection-"] .esr-fbt-full-width .cbb-frequently-bought-product-image{margin-left:auto!important;margin-right:auto!important;}' +
      '[id^="ProductSection-"] .esr-fbt-full-width .cbb-frequently-bought-recommendations-container{height:auto!important;width:100%!important;}' +
      '[id^="ProductSection-"] .esr-fbt-full-width .esr-fbt-summary-list{background:#191819;border-radius:8px;box-sizing:border-box;list-style:none;margin:12px 0 0!important;padding:14px 16px!important;width:100%!important;}' +
      '[id^="ProductSection-"] .esr-fbt-full-width .esr-fbt-summary-list .cbb-frequently-bought-product-form-tile{background:transparent!important;border:0!important;box-shadow:none!important;margin:0!important;max-width:none!important;padding:0!important;width:100%!important;}' +
      '[id^="ProductSection-"] .esr-fbt-full-width .cbb-frequently-bought-form{align-items:center;display:flex!important;gap:20px;justify-content:space-between;width:100%;}' +
      '[id^="ProductSection-"] .esr-fbt-full-width .cbb-frequently-bought-total-price-box{margin:0!important;}' +
      '[id^="ProductSection-"] .esr-fbt-full-width .cbb-frequently-bought-total-price-text{color:#fff!important;font-size:14px;font-weight:700!important;}' +
      '[id^="ProductSection-"] .esr-fbt-full-width .cbb-frequently-bought-total-price-sale-price{color:#fff!important;font-size:20px;font-weight:900!important;}' +
      '[id^="ProductSection-"] .esr-fbt-full-width .cbb-frequently-bought-total-price-was-price{color:#aeb5b5!important;}' +
      '[id^="ProductSection-"] .esr-fbt-full-width .cbb-frequently-bought-add-button{background:#d71d24!important;border:1px solid #d71d24!important;border-radius:5px!important;box-shadow:none!important;min-height:48px;padding:13px 28px!important;transition:background .2s ease,transform .2s ease!important;}' +
      '[id^="ProductSection-"] .esr-fbt-full-width .cbb-frequently-bought-add-button:hover{background:#ef2630!important;transform:translateY(-1px);}' +
      '[id^="ProductSection-"] .esr-fbt-full-width .esr-fbt-scroll-button{align-items:center;background:#191819!important;border:2px solid #fff!important;border-radius:50%;box-shadow:0 5px 16px rgba(0,0,0,.22);color:#fff!important;cursor:pointer;display:flex;height:42px;justify-content:center;line-height:1;padding:0;position:absolute;top:42%;transform:translateY(-50%);transition:background .2s ease,opacity .2s ease,transform .2s ease;width:42px;z-index:5;}' +
      '[id^="ProductSection-"] .esr-fbt-full-width .esr-fbt-scroll-button:hover,[id^="ProductSection-"] .esr-fbt-full-width .esr-fbt-scroll-button:focus-visible{background:#d71d24!important;outline:2px solid #d71d24;outline-offset:2px;transform:translateY(-50%) scale(1.05);}' +
      '[id^="ProductSection-"] .esr-fbt-full-width .esr-fbt-scroll-button.is-disabled{cursor:default;opacity:.22;pointer-events:none;}' +
      '[id^="ProductSection-"] .esr-fbt-full-width .esr-fbt-scroll-button--previous{left:2px;}' +
      '[id^="ProductSection-"] .esr-fbt-full-width .esr-fbt-scroll-button--next{right:2px;}' +
      '.esr-fbt-optional-message{color:#596565!important;font-size:13px!important;font-weight:700!important;margin:0 0 12px!important;}' +
      '.esr-reviews .jdgm-rev-widg__title{display:none!important;}' +
      '.esr-standard-product .esr-product-section{padding-bottom:54px!important;padding-top:54px!important;}' +
      '.esr-description{gap:44px!important;}' +
      '@media(max-width:989px){[id^="ProductSection-"] .esr-fbt-full-width .cbb-frequently-bought-products{grid-auto-columns:calc((100% - 28px)/3)!important;}}' +
      '@media(max-width:559px){[id^="ProductSection-"] .photos__item--thumbs{padding:0 38px!important;}' +
      '[id^="ProductSection-"] .product-single__photo,[id^="ProductSection-"] .product-single__photo>a{height:390px;max-height:390px!important;}' +
      '[id^="ProductSection-"] .product-single__photo img{max-height:390px!important;}' +
      '[id^="ProductSection-"] .esr-main-gallery-arrow{height:27px;width:27px;}' +
      '[id^="ProductSection-"] .esr-main-gallery-arrow--previous{left:8px;}' +
      '[id^="ProductSection-"] .esr-main-gallery-arrow--next{right:8px;}' +
      '[id^="ProductSection-"] .esr-thumb-arrow{height:32px;width:32px;}' +
      '[id^="ProductSection-"] .esr-thumb-arrow--previous{left:-35px;}' +
      '[id^="ProductSection-"] .esr-thumb-arrow--next{right:-35px;}' +
      '[id^="ProductSection-"] .esr-fbt-full-width{padding:22px 14px 24px;}' +
      '[id^="ProductSection-"] .esr-fbt-full-width .esr-fbt-carousel-shell{padding:0;}' +
      '[id^="ProductSection-"] .esr-fbt-full-width .cbb-frequently-bought-products{gap:12px!important;grid-auto-columns:78%!important;padding-right:12px!important;}' +
      '[id^="ProductSection-"] .esr-fbt-full-width .esr-fbt-scroll-button{display:none!important;}' +
      '[id^="ProductSection-"] .esr-fbt-full-width .cbb-frequently-bought-form{align-items:stretch;flex-direction:column;gap:12px;}' +
      '[id^="ProductSection-"] .esr-fbt-full-width .cbb-frequently-bought-add-button{width:100%!important;}' +
      '.esr-standard-product .esr-product-section{padding-bottom:44px!important;padding-top:44px!important;}}';
    document.head.appendChild(style);

    enableHighResolutionGallery();
    enableMainGalleryNavigation();
    enableFbtNavigation();
    watchPaymentIconAltText();
    schedulePremiumThumbnails();

    observer = new MutationObserver(function () {
      configureFbt();
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });

    var interval = window.setInterval(function () {
      configureFbt();
      if (completed || attempts >= maxAttempts) {
        window.clearInterval(interval);
      }
    }, 400);

    window.setTimeout(function () {
      window.clearInterval(interval);
    }, 12000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }
})();
